import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './fielder_style.css';
import FieldListings from './FieldListings';
import PublicNavbar from './PublicNavbar'; // Import the PublicNavbar component
import Footer from './Footer';
import useRootBackground from '../hooks/useRootBackground';

function Explore() {
  useRootBackground('var(--bg-page)'); // white hero at the top — keep the status-bar strip white
  return (
    <div>
      {/* NAVBAR */}
      <PublicNavbar />

      {/* LISTINGS */}

      <FieldListings />

      {/* FOOTER — rendered on the Explore/home page only */}
      <Footer />

    </div>
  );
}

export default Explore;
